import React, {
    createContext, useState, useMemo, useEffect, useCallback,
} from "react";
import navigate from "@helpers/link-navigate";
import useDebounce from "@root/hooks/useDebounce";

export const CategoryContext = createContext();

export const CategoryProvider = ({ children, baseCategory, currentCategory = null, currentCategoryProducts = [], pageData }) => {
    const [_baseCategory, setBaseCategory] = useState(baseCategory);
    const [_currentCategory, setCurrentCategory] = useState(currentCategory);
    const [_currentCategoryProducts, setCurrentCategoryProducts] = useState(currentCategoryProducts);
    const [activeSlug, setActiveSlug] = useState(currentCategory?.slug || baseCategory?.slug);
    const [loading, setLoading] = useState(false);
    const loadingDebounce = useDebounce(loading, (v) => (v ? 100 : 0));

    const navigateToCategory = useCallback(async (category) => {
        if (category.url) {
            if (category.slug === activeSlug) return;

            setActiveSlug(category.slug);
            await navigate(category.url, { state: { preventScroll: true } });

            setLoading(true);
        }
    }, [activeSlug]);

    const value = useMemo(() => ({
        baseCategory: _baseCategory,
        currentCategory: _currentCategory,
        currentCategoryProducts: _currentCategoryProducts,

        setBaseCategory,
        setCurrentCategory,
        setCurrentCategoryProducts,

        navigateToCategory,

        loading: loadingDebounce,

        pageData,
    }), [_baseCategory, _currentCategory, _currentCategoryProducts, loadingDebounce]);

    useEffect(() => {
        // if (activeSlug === currentCategory?.slug) {
        setCurrentCategory(currentCategory);
        // }
    }, [currentCategory, activeSlug]);

    useEffect(() => {
        // if (activeSlug === currentCategory?.slug) {
        setCurrentCategoryProducts(currentCategoryProducts);
        setLoading(false);
        // }
    }, [currentCategoryProducts, currentCategory, activeSlug]);

    return (
        <CategoryContext.Provider value={value}>
            {children}
        </CategoryContext.Provider>
    );
};
